<template>
  <div class="userCenter">
    <job-header-simple header_title="基本信息" :backRouter="backRouter"></job-header-simple>
 
    <van-cell-group style="margin: 8px 0px">
      <van-cell class="item item-weight" title="基本信息"/>
      <van-cell class="item" title="用户姓名" :value="user.name" />
      <van-cell class="item" title="手机号码" :value="user.mobile" />
      <template v-for="item in papersTypeOptions">
        <van-cell
          class="item"
          title="证件类型"
          v-if="user.papersType == item.code"
          :value="item.value"
          :key="item.id"
        ></van-cell>
      </template>
      <van-cell class="item" title="证件号码" :value="user.idNumber"></van-cell>
      <van-cell class="item" title="实名状态" value="已认证" />
    </van-cell-group>

    <van-cell-group style="margin: 8px 0px">
      <van-cell class="item item-weight" title="工商信息"/>
      <van-cell class="item" title="个体户编号" :value="user.firmId" />
      <van-cell class="item" title="个体户名称" :value="user.firmName" />
      <van-cell class="item" title="营业执照号" :value="user.yyzzNo" />
    </van-cell-group>

    
    <van-cell-group>
      <van-cell title="收款信息" class="item-weight"/>
      <van-cell
        is-link
        :to="{path:'/card?type=0&contractId='+this.$route.query.obj+'&ocompanyId='+this.$route.query.ocompanyId}"
        class="item"
        title="收款名称"
        :value="!user.card_type?'选择账号':user.card_type"
      ></van-cell>
      <van-cell class="item" title="收款账号" :value="user.card_id"></van-cell>
    </van-cell-group>

    <div class="bottom">
      <van-checkbox
        name="1"
        class="text_gray agreement_line"
        checked-color="#6c7ef3"
        v-model="agreement"
        @change="setCheckBox"
      >同意</van-checkbox>
      <router-link to="/dianqianxieyi">《电签协议》</router-link>
      <div class="help-link" @click="showHelp = true">
        电签帮助
        <van-icon name="question"></van-icon>
      </div>
      <van-button type="info" size="large" to class="btn_theme" @click="sign()">开始电签</van-button>
    </div>

    <van-dialog v-model="showHelp">
      <div class="helpContent">
        <p>电子合同是双方或多方当事人之间通过电子信息网络以电子的形式达成的设立、变更、终止财产性民事权利义务关系的协议。</p>
        <p>依据《中华人民共和国电子签名法》 [2] 第十四条：“可靠的电子签名与手写签名或者盖章具有同等的法律效力。”《电子签名法》对可靠的电子签名的规定是：“电子签名同时符合下列条件的，视为可靠的电子签名：</p>
        <p>1）电子签名制作数据用于电子签名时，属于电子签名人专有；</p>
        <p>2）签署时电子签名制作数据仅由电子签名人控制；</p>
        <p>3）签署后对电子签名的任何改动能够被发现；</p>
        <p>4）签署后对数据电文内容和形式的任何改动能够被发现；</p>
        <p>电子合同是当事人就一定的事件约定的双方权利义务归属了的文书，是电子合同履行的依据。电子合同有效的约定了合同双方或多方的权利和义务，对电子合同的履行有积极的作用，能够较为有效的约束违约行为，能够最大程度的保障自己的合法权利。</p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  Image,
  Cell,
  CellGroup,
  Button,
  NavBar,
  CheckboxGroup,
  Checkbox,
  Dialog,
  Toast,
  Icon,
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import { goBack } from "@/utils/index.js";
import api from "@/api/list";
import { browserUA } from "@/utils/browserUA";
const srcheader = require("@/assets/user1.png");
export default {
  components: {
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    jobHeaderSimple,
  },
  data() {
    return {
      srcheader: srcheader
        ? srcheader
        : require("../../assets/img_default.png"),
      user: {},
      papersTypeOptions: [],
      showHelp: false,
      agreement: false,
      backRouter: "0",
    };
  },
  // 回退页面问题
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.backRouter = "/contractList";
    });
  },
  beforeRouteLeave(to, from, next) {
    if (from.path == "/contractList") {
      this.$store.commit("SET_CHECKEDESIGN", false);
    }
    next();
  },
  created() {
    this.getPaperType();
    this.initActiveUserInfo();
    this.agreement = this.$store.getters.checkedEsign;
  },
  methods: {
    getPaperType() {
      api.getDataDictList({ group: "papersType" }).then((response) => {
        this.papersTypeOptions = response.data.data;
      });
    },
    setCheckBox(val) {
      this.$store.commit("SET_CHECKEDESIGN", val);
    },
    signContractUrl(url) {
      browserUA().then((browserType) => {
        if (browserType == "androidAPP") {
          window.VpShopJs.signContract(JSON.stringify({ url: url }));
        } else {
          window.open(url, "_self");
        }
      });
    },
    sign() {
      if (this.agreement) {
        if (this.user.certificationStatus == "AUTHENTICATIONOK") {
          // 已认证
          if (
            typeof this.user.card_type != "undefined" &&
            typeof this.user.card_id != "undefined"
          ) {
            // 银行卡名称和银行卡账号不为空(协议绑定了银行卡)
            if (typeof this.$route.query.val == "undefined") {
              if (this.user.signUrl != null) {
                this.signContractUrl(this.user.signUrl);
              } else {
                // 向e签宝发起协议申请
                this.createEmployeeContract({ id: this.$route.query.obj ,type:1});
              }
            } else {
              api
                .bank(
                  {
                    name: this.user.card_type,
                    bankNo: this.user.card_id.replace(/\s/g, ""),
                    contractId: this.$route.query.obj,
                  },
                  { method: "post" }
                )
                .then((res) => {
                  if (res.data.status == "200") {
                    this.$store.commit("SET_CARDTYPE", undefined);
                    this.$store.commit("SET_CARDID", undefined);
                    if (this.user.signUrl != null) {
                      this.signContractUrl(this.user.signUrl);
                    } else {
                      // 向e签宝发起协议申请
                      this.createEmployeeContract({
                        id: this.$route.query.obj,
                      });
                    }
                  }
                });
            }
          } else {
            this.$toast({
              message: "请先选择收款账号！",
            });
          }
        } else {
          this.$toast({
            message: "请先完成实名认证！",
          });
        }
      } else {
        this.$toast({
          message: "请勾选同意协议！",
        });
      }
    },
    mouse() {
      if (!this.user.card_type || !this.user.card_id) {
        Dialog.alert({
          title: "提示",
          message: "请选择收款账号",
        }).then(() => {});
      } else {
        if (this.user.papersType !== "1") {
          this.$router.push({
            path: "/identity",
            query: {
              bankCard: this.user.card_id,
              bankName: this.user.card_type,
              papersType: this.user.papersType,
              contractId: this.$route.query.obj,
             type: this.user.cerficationTypes,
            },
          });
        } else {
          if ("card" === this.user.cerficationTypes) {
            this.$router.push({
              path: "/identity",
              query: {
                bankCard: this.user.card_id,
                bankName: this.user.card_type,
                contractId: this.$route.query.obj,
                type: this.user.cerficationTypes,
              },
            });
          } else if ("face" === this.user.cerficationTypes) {
            this.$router.push({
              path: '/identity',
              query: {
                bankCard: this.user.card_id,
                bankName: this.user.card_type,
                bankMobile: this.user.card_phone,
                contractId: this.$route.query.obj,
                front: this.user.front,
                back: this.user.back,
                bankCardId: this.user.bankCardId,
                type: this.user.cerficationTypes,
              },
            })
            // let param ={
            //       bankCardId: this.user.bankCardId,
            //       contractId: this.$route.query.obj
            // }
            // api.individualFace(param).then((res) => {
            //   if (res.status == "200") {
            //     let json = JSON.parse(res.data.data);
            //     if (json == null) {
            //       Toast.fail(res.data.message);
            //     } else {
            //       browserUA().then((browserType) => {
            //         if (browserType == "androidAPP") {
            //           window.VpShopJs.bodyCheck(
            //             JSON.stringify({ url: json.url })
            //           );
            //         } else {
            //           location.href = json.url;
            //         }
            //       });
            //     }
            //   } else {
            //     Toast.fail("发起认证失败");
            //   }
            // });
          } else {
            this.$router.push({
              path: "/identitySelection",
              query: {
                bankCard: this.user.card_id,
                bankName: this.user.card_type,
                bankCardId: this.user.bankCardId,
                contractId: this.$route.query.obj,
                cerficationTypes: this.user.cerficationTypes
              },
            });
          }
        }
      }
    },
    initActiveUserInfo() {
      api
        .employeeGetAllInfo({ contractId: this.$route.query.obj,ocompanyId: this.$route.query.ocompanyId })
        .then((res) => {
          if (res.data.status == "200") {
            this.user = res.data.data;
            this.user.company = this.$route.query.name;
            if (res.data.data.bankName != null) {
              this.user.card_type = res.data.data.bankName;
              this.user.card_id = res.data.data.bankAccount;
            } else {
              this.$store.commit("SET_CARDTYPE", undefined);
              this.$store.commit("SET_CARDID", undefined);
            }
            if (
              res.data.data.headshot &&
              typeof res.data.data.headshot != "undefined"
            ) {
              this.srcheader =
                process.env.VUE_APP_FILE_PATH + res.data.data.headshot;
            }
            this.user.certificationStatus = res.data.data.certificationStatus;
            if (typeof this.$route.query.val != "undefined") {
              this.user.card_type = this.$route.query.val.bank_name;
              this.user.card_id = this.$route.query.val.account;
              this.user.bankCardId = this.$route.query.val.id;
            }
            if (this.user.card_type == undefined) {
              if (this.$store.getters.card_type != "undefined") {
                this.user.card_type = this.$store.getters.card_type;
              }
            } else {
              this.$store.commit("SET_CARDTYPE", this.user.card_type);
            }
            if (this.user.card_id == undefined) {
              if (this.$store.getters.card_id != "undefined") {
                this.user.card_id = this.$store.getters.card_id;
              }
            } else {
              this.$store.commit("SET_CARDID", this.user.card_id);
            }
          }
        });
    },
    goBack() {
      goBack();
    },
    createEmployeeContract(obj) {
      // 向e签宝发起协议申请
      const toastLoading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      api.createContract(obj, { method: "post" }).then((res) => {
        toastLoading.clear(); //关闭加载效果
        if (res.data.status == "200") {
          this.signContractUrl(res.data.data);
        } else {
          this.$toast({
            message: "签署协议失败，请稍后再试！",
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.item-weight{
  font-weight: 600;
}
.userCenter {
  .item {
    color: #333;
    overflow: visible;

    .van-icon-arrow {
      color: #ddd;
    }

    .van-cell__value {
      color: #333;
      overflow: visible;
    }
  }

  .item_radio {
    display: inline-block;

    & + .item_radio {
      margin-left: 20px;
    }
  }

  .icon_finger {
    position: absolute;
    right: 40px;
    top: 7.5px;
    display: block;
    width: 46px;
    height: 68px;
    background: url("../../assets/finger.png") center center no-repeat;
    background-size: contain;
    z-index: 99;
  }

  .bottom {
    background: #fff;
    padding: 0 40px 40px;
    .agreement_line {
      padding: 24px 0;
      font-size: 13px;
      display: inline-block;
      vertical-align: middle;
      /deep/ .van-checkbox__icon {
        display: inline-block;
        vertical-align: middle;
      }
    }

    a {
      font-size: 13px;
      color: #6c7ef3;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

@-webkit-keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse {
  from {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

.help-link {
  display: inline-block;
  vertical-align: middle;
  color: #6c7ef3;
  font-size: 13px;
  text-align: right;
  //margin-left: 10px;
  /deep/ .van-icon {
    font-size: 16px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 3px;
    margin-top: -3px;
  }
}

.helpContent {
  padding: 6px 10px 6px 12px;
  font-size: 12px;
  line-height: 16px;
  p {
    margin: 6px 0;
  }
}
.text_gray {
  .van-radio__label {
    color: #999;
  }
}
</style>


